import React from "react";
import { GooeyFilter, Toggle } from "../../ui/liquid-toggle";

interface ToggleProps {
  isChecked: boolean;
  onToggleChange?: (newState: boolean) => void;
}

const ToggleBtn: React.FC<ToggleProps> = ({ isChecked, onToggleChange }) => {
  const handleToggle = (checked: boolean) => {
    if (onToggleChange) {
      onToggleChange(checked);
    }
  };

  return (
    <div className="relative">
      <GooeyFilter />
      <Toggle
        variant="default"
        checked={isChecked}
        onCheckedChange={handleToggle}
      />
    </div>
  );
};

export default ToggleBtn;
